<template>
    <v-card>
        <div v-padding.left="3" v-padding.right="3" v-padding.top="2" v-padding.bottom="2">
            <v-text type="headline">
                История
            </v-text>
        </div>

        <v-data-table empty="Вы пока не сделали ни одного платежа" :loader="loading" @sort="$emit('sort', $event)" :sort="sort" :headers="headers" :records="records">
            <template slot="cell-datetime" scope="props">
                <v-text nowrap>
                    {{ moment(props.item.datetime).format('DD.MM.YYYY HH:mm') }}
                </v-text>
            </template>

            <template slot="cell-expires" scope="props">
                <v-text nowrap>
                    {{ moment(props.item.expires).format('DD.MM.YYYY') }}
                </v-text>
            </template>

            <template slot="cell-statusName" scope="props">
                <v-text nowrap>
                    {{ props.item.statusName }}
                </v-text>
            </template>

            <template slot="cell-paymentType" scope="props">
                <v-text>
                    {{ METHODS_STRING[props.item.paymentType] }}
                </v-text>
            </template>

            <template slot="cell-summa" scope="props">
                <v-text nowrap>
                    {{ numberWithSpaces(props.item.summa) }}
                </v-text>
            </template>

            <template slot="cell-accountPrint" scope="props">
                <v-text v-if="props.item.isPrintable">
                    <v-link target="_blank" :to="`/api/v1/finance/fundHistory/html?id=${props.item.id}`" v-margin.right="1">
                        HTML
                    </v-link>

                    <v-link target="_blank" :to="`/api/v1/finance/fundHistory/pdf?id=${props.item.id}`">
                        PDF
                    </v-link>
                </v-text>
            </template>
        </v-data-table>

        <div v-padding="3">
            <v-pagination @click="$emit('paginate', $event)" :total="total" :display="display" :current="page" />
        </div>
    </v-card>
</template>
<script>
    import moment from 'moment';
    import { METHODS_STRING } from '../pricing/constants';
    import { numberWithSpaces } from '../../../helpers';

    export default {
        name: 'payment-history',
        props: {
            loading: Boolean,
            sort: Object,
            records: Array,
            total: {
                type: Number,
                default: 0,
            },
            page: {
                type: Number,
                default: 1,
            },
            display: {
                type: Number,
                default: 10,
            },
        },
        data() {
            return {
                METHODS_STRING,
                headers: {
                    datetime: { label: 'Дата / Время' },
                    paymentType: { label: 'Способ оплаты' },
                    summa: { label: 'Сумма руб.' },
                    statusName: { label: 'Статус' },
                    expires: { label: 'Срок действия до' },
                    accountPrint: { label: 'Действие' }
                }
            }
        },
        methods: {
            moment,
            numberWithSpaces,
        }
    }
</script>



// WEBPACK FOOTER //
// PaymentHistory.vue?0a1d47eb